import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { getSafeRedirectUrl, LoginPage, sessionQueryOptions } from '@/features/auth';

const loginSearchSchema = z.object({
	redirect: z.string().optional(),
});

export const Route = createFileRoute('/login')({
	validateSearch: loginSearchSchema,
	beforeLoad: async ({ context, search }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueryOptions).catch(() => null);

		if (session) {
			throw redirect({
				to: getSafeRedirectUrl(search.redirect),
			});
		}
	},
	component: LoginRoute,
});

function LoginRoute() {
	const navigate = useNavigate();
	const { redirect: redirectParam } = Route.useSearch();

	return (
		<LoginPage
			onSuccess={() => {
				navigate({ to: getSafeRedirectUrl(redirectParam) });
			}}
		/>
	);
}
